
<router-outlet></router-outlet>
<app-loader></app-loader>
<app-dialog-box></app-dialog-box>
<app-eligibility></app-eligibility>
<app-waiting-screen></app-waiting-screen>
<app-toaster></app-toaster>
